module.exports = __webpack_public_path__ + "img/case_thumbnail.0c1f4dce.png";